const LogoPath =
  "M19.9095 0V10.4736L9.95587 0H0V10.7632H19.638L9.819 21.6724V32H19.9095V10.7632H30V0H19.9095Z";

interface TSLogoProps {
  fill?: string;
  width?: string;
  height?: string;
  className?: string;
}

export default function TSLogo({
  fill = "white",
  width = "3.75rem",
  height = "4rem",
  className,
}: TSLogoProps) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      viewBox="0 0 30 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
    >
      <path d={LogoPath} fill={fill} />
    </svg>
  );
}
